import attachmentService from './attachment.service';
import http from './http-common';

class WorkOrderService {
  async uploadAndAddAttachmentsToWorkOrder(workOrderId: number, file: File) {
    const attachmentId = await attachmentService.fileUpload(file);

    return await this.addAttachmentsToWorkOrder(workOrderId, [attachmentId]);
  }

  async addAttachmentsToWorkOrder(workOrderId: number, attachmentIds: number[]) {
    return http.post('/work-order/attachments/add', { workOrderId, attachmentIds });
  }

  async removeAttachmentsFromWorkOrder(workOrderId: number, attachmentIds: number[]) {
    return http.post('/work-order/attachments/remove', { workOrderId, attachmentIds });
  }
}

const workOrderService = new WorkOrderService();
export default workOrderService;
